import { invoiceLanguages } from '../constants/invoiceLanguages'
import type { InvoiceLanguage } from '../types/invoiceLanguage'

export const isInvoiceLanguage = (value: unknown): value is InvoiceLanguage =>
  invoiceLanguages.includes(value as InvoiceLanguage)
